import { useMemo } from "react";

import { styles } from "@repo/helpers";

import { InputComponent } from "../../basic/input";
import { DdlValue, MobileMarkupProps } from "../types";
import style from "./style.module.scss";

export default function DropDownMarkup(args: MobileMarkupProps) {
	const { id, name, valueProp, textProp, value, values, disabled, className, loaded = true, onChange } = args;

	const vals = useMemo(() => {
		if (valueProp === undefined || textProp === undefined) return values;
		if (!values?.map) return values;
		return values.map((val: any) => {
			return {
				value: val[valueProp],
				label: val[textProp],
			};
		});
	}, [values, valueProp, textProp]);

	const opts = useMemo(
		() =>
			vals.map((n) => (
				<option key={n.value} value={n.value} selected={n.value === (value as DdlValue)?.value}>
					{n.label}
				</option>
			)),
		[vals],
	);
	const nullOptionSelected = value === null;
	const fullClassName = styles(
		style.select,
		args.fullLength && style.fullLength,
		nullOptionSelected && style.emptyDdlOption,
		className,
	);
	const nullOptionPlaceholder = loaded ? "Select..." : "Loading...";
	const nullOption = (args.clearable || nullOptionSelected || !loaded) && (
		<option value={""} selected={nullOptionSelected}>
			{nullOptionPlaceholder}
		</option>
	);
	return (
		<InputComponent {...args}>
			<select name={name || id} onChange={onChange} className={fullClassName} disabled={!loaded || disabled}>
				{nullOption}
				{opts}
			</select>
		</InputComponent>
	);
}
